// اضافه کردن کتابخانه ها به صفحه
import * as React from "react"
import {createSearchParams, Link, NavLink, useLocation, useNavigate} from "react-router-dom";

import {AccountBox, Https, KeyboardBackspace, PhoneIphone, Visibility, VisibilityOff} from '@mui/icons-material';
import {useTheme} from '@mui/material/styles';

import {useTranslation} from "react-i18next";

// اضافه کردن پلاگین axios
import {Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, useMediaQuery} from "@mui/material";
import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {handleBorderColor, HandleValidationMethod, removeNonNumeric, useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setValidations} from "../../redux/public/actions";


export default function Register() {

  // جابه جایی بین صفحات در متد ها
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const location = useLocation();

  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t, i18n} = useTranslation()
  const langStorage = localStorage.getItem('i18nextLng');
  const {fetchData} = HandleFetchData()
  const {showMessageComponent} = useShowMessageComponent()
  const {validationMethod} = HandleValidationMethod()

  // متغیر و useState های لوکال صفحه
  const [phone, setPhone] = React.useState('')
  const [initCode, setInitCode] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [errOnlyEnglish, setErrOnlyEnglish] = React.useState('')
  const [confirmPassword, setConfirmPassword] = React.useState('')
  const [showPassword, setShowPassword] = React.useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false)
  const [dialogRules, setDialogRules] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [rulesItem, setRulesItem] = React.useState([
    {
      label: 'rules.s1.t1',
      items: [
        'rules.s1.t2',
        'rules.s1.t3',
        'rules.s1.t4',
        'rules.s1.t5',
        'rules.s1.t6',
        'rules.s1.t7',
        'rules.s1.t8',
        'rules.s1.t9',
        'rules.s1.t10',
        'rules.s1.t11',
        'rules.s1.t12',
        'rules.s1.t13',
        'rules.s1.t14',
        'rules.s1.t15',
        'rules.s1.t16',
        'rules.s1.t17',
        'rules.s1.t18',
        'rules.s1.t19',
        'rules.s1.t20',
      ]
    },
    {
      label: 'rules.s2.t1',
      items: [
        'rules.s2.t2',
        'rules.s2.t3',
        'rules.s2.t4',
        'rules.s2.t5',
        'rules.s2.t6',
        'rules.s2.t7',
        'rules.s2.t8',
      ]
    },
    {
      label: 'rules.s3.t1',
      items: [
        'rules.s3.t2',
        'rules.s3.t3',
        'rules.s3.t4',
        'rules.s3.t5',
        'rules.s3.t6',
      ]
    },
  ])


  // اضافه کردن Attribute به dom پروژه
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir(i18n.language));


  const onlyEnglish = (e) => {
    var re = new RegExp(/[^A-Za-z0-9!@#\$%\^\&*]/g);
    if (re.test(e.toString())) {
      // alert()
      setErrOnlyEnglish('کیبورد خود را به انگلیسی تغییر دهید')
      return e.toString().replace(re, "")
    } else {
      setErrOnlyEnglish('')
      return e.toString()
    }
  };


  const validationInput = (event) => {
    event.preventDefault();

    !phone ?
       validationMethod('', "phone", t("error.t6"))
       :
       phone?.length !== 11 || !phone.startsWith("09") ?
          validationMethod('', 'phone', t("error.t7"))
          :
          !initCode ?
             validationMethod('', 'initCode', t("error.t31"))
             :
             !password ?
                validationMethod('', 'password', t("error.t32"))
                :
                !confirmPassword ?
                   validationMethod('', 'confirmPassword', t("error.t33"))
                   :
                   (password !== confirmPassword) ?
                      showMessageComponent(t("error.t34"), 'error')
                      :
                      handleRegister()
  }

  // متد ارسال اطلاعات کاربر و ثبت نام
  const handleRegister = async () => {
    dispatch(setValidations(null))
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/customer/register', {
         CodeMeli: initCode,
         Username: phone,
         Password: password,
         affiliateName: sessionStorage.getItem('affiliate')
       },
       "application/x-www-form-urlencoded", '', '', ''
    )
    if (fetch?.Status == 200) {
      getVerifyCode()
      navigate({
        pathname: "/auth/verifyCode",
        search: createSearchParams({
          phone: phone
        }).toString()
      });
      showMessageComponent(fetch[`message_${langStorage}`] || '', 'success')
    } else if (fetch && fetch?.Status == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch[`message_${langStorage}`] || '', 'error')
    }
    dispatch(setLoading(fetch?.isLoading))
  }

  const getVerifyCode = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/sendActivationCode', {
         "mobileNo": phone,
       },
       "application/x-www-form-urlencoded", '', '', ''
    )

    if (fetch?.IsSuccess) {
      // navigate('/', {replace: true})
      showMessageComponent(fetch?.Message, 'success')

    } else if (fetch && fetch?.Status == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch?.Message, 'error')
    }
    dispatch(setLoading(fetch.isLoading))
  }


  return (
     <>
       <div className="authPage">
         <div className="container">
           <div className="row">
             <div className="col-12 col-lg-3 col-xl-4"/>
             <div className="col-12 col-lg-6 col-xl-4 ">
               <div className="body-page">

                 <div className="logo">
                   <NavLink to='/tracking'>
                     <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt="پستِکس"/>
                   </NavLink>
                 </div>

                 <h6 className="description">{t("register.t1")}</h6>
                 <hr/>

                 <form onSubmit={validationInput}>
                   <h6 className="title">{t("register.t2")}</h6>
                   <div className="input">
                     <PhoneIphone/>
                     {/*<span className="countryCode">+98</span>*/}
                     <input type="text" placeholder={t("register.t3")}
                            className="phoneNumber numeric" value={phone} id="phone"
                            style={handleBorderColor(selector?.public?.validations?.phone)}
                            onChange={e => e.target.value.length <= 11 && setPhone(removeNonNumeric(e.target.value))}/>
                   </div>
                   {
                     selector?.public?.validations?.phone &&
                     <p className="error">{selector?.public?.validations?.phone}</p>
                   }

                   <div className="input">
                     <AccountBox/>
                     <input type="text" placeholder={t("register.t4")} className="numeric" value={initCode} id="code" style={handleBorderColor(selector?.public?.validations?.initCode)}
                            onChange={e => e.target.value.length <= 10 && setInitCode(removeNonNumeric(e.target.value))}/>
                   </div>
                   {
                     selector?.public?.validations?.initCode &&
                     <p className="error">{selector?.public?.validations?.initCode}</p>
                   }
                   <div className="input">
                     <Https/>
                     <input type={!showPassword ? 'password' : 'text'} name="password" placeholder={t("register.t5")} style={handleBorderColor(selector?.public?.validations?.password)}
                            value={password} id="password"
                            className="inputPass" onChange={e => setPassword(onlyEnglish(e.target.value))}/>

                     <button type="button" onClick={() => setShowPassword(!showPassword)} id="showPassword">
                       {
                         showPassword ?
                            <VisibilityOff/>
                            :
                            <Visibility/>
                       }
                     </button>
                   </div>
                   {
                     (selector?.public?.validations?.password || errOnlyEnglish) &&
                     <p className="error">{selector?.public?.validations?.password || errOnlyEnglish}</p>
                   }

                   <div className="input">
                     <Https/>
                     <input type={!showConfirmPassword ? 'password' : 'text'} name="password"
                            placeholder={t("register.t6")} id="confirmPassword"
                            value={confirmPassword}
                            style={handleBorderColor(selector?.public?.validations?.confirmPassword)}
                            className="inputPass" onChange={e => setConfirmPassword(onlyEnglish(e.target.value))}/>


                     <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} id="showConfirmPassword">
                       {
                         showConfirmPassword ?
                            <VisibilityOff/>
                            :
                            <Visibility/>
                       }
                     </button>
                   </div>

                   {
                     (selector?.public?.validations?.confirmPassword || errOnlyEnglish) &&
                     <p className="error">{selector?.public?.validations?.confirmPassword || errOnlyEnglish}</p>
                   }


                   {/*دکمه ثبت نام کاربر*/}
                   <div className="_btnGroup_blue">
                     <button type="submit" className="btnFill" id="validationInput">
                       {
                         selector?.loading?.isLoading ?
                            <Box sx={{display: 'flex'}}>
                              <CircularProgress size={20}/>
                            </Box>
                            :
                            <span>{t("register.t7")}</span>
                       }
                     </button>
                   </div>
                 </form>


                 {/*قوانین وب سایت  هنگام ثبت نام*/}
                 <div className="rules">
                   <p>{t("register.t8")}</p>
                   {/*<Link to={{pathname: '/rules', search: location?.search}}>{t("register.t9")}</Link>*/}
                   <button type="button" onClick={() => setDialogRules(true)} id="openDialogRules">{t("register.t9")}</button>
                 </div>

                 {/*دکمه رفتن به صفحه ورود*/}
                 <div className="route-link">
                   <p>{t("register.t10")}</p>
                   <Link to={{pathname: '/auth/login', search: location?.search}} id="login">{t("register.t11")}</Link>
                 </div>

                 {/*دکمه برگشت به صفحه اصلی*/}
                 <Link to={{pathname: '/', search: location?.search}} className="goBack" id="home">
                   <p>{t("register.t12")}</p>
                   <KeyboardBackspace/>
                 </Link>

               </div>
             </div>
             <div className="col-12 col-lg-3 col-xl-4"/>
           </div>
         </div>


         <Dialog
            fullScreen={fullScreen}
            open={dialogRules}
            onClose={() => setDialogRules(false)}
            aria-labelledby="responsive-dialog-title"
            className="dialog-rules-register"
         >
           <DialogContent>
             <DialogContentText>
               <div className="container">
                 <div className="row">
                   <div className="col-12">

                     <h2>{t("rules.t1")}</h2>
                     <p>{t("rules.t2")}</p>

                     <div className="items">
                       {
                         rulesItem?.map((item, index) => {
                           return (
                              <div className="item" key={index}>
                                <h4>{t(item?.label)}</h4>
                                <ul>
                                  {
                                    item?.items?.map((item2, index2) => {
                                      return (
                                         <li key={index2}>{t(item2)}</li>
                                      )
                                    })
                                  }
                                </ul>

                              </div>
                           )
                         })
                       }
                     </div>
                   </div>
                 </div>
               </div>
             </DialogContentText>
           </DialogContent>
           <DialogActions>
             <Button autoFocus onClick={() => setDialogRules(false)} id="closeDialogRules">
               {t("register.t16")}
             </Button>
           </DialogActions>
         </Dialog>

       </div>
     </>
  )
}
